// extracted by mini-css-extract-plugin
export var smallSpinner = "_sb-0";